// extracted by mini-css-extract-plugin
module.exports = {"bioWrapper":"_18d3n8","avatarWrapper":"BVWMl3","headTextWrapper":"_2m26C5","headWrapper":"_1DhlT1"};